var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgApps = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10 2.7a2 2 0 0 1 2 2v4.1a2 2 0 0 1-2 2H5.9a2 2 0 0 1-2-2V4.7a2 2 0 0 1 2-2H10ZM6.1 0a2 2 0 0 1 1.937 1.499L4.7 1.5a2 2 0 0 0-1.995 1.85L2.7 3.5v4.4c0 .067.003.134.01.2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h4.1Z"
})));

export default SvgApps;